import Vue from 'vue'
import Router from 'vue-router'

//page
const login = r => require.ensure([], () => r(require('@/page/login')), 'login');
const manage = r => require.ensure([], () => r(require('@/page/manage')), 'manage');
// const home = r => require.ensure([], () => r(require('@/page/home')), 'home');
const teacher_class = r => require.ensure([], () => r(require('@/page/teacher_class')), 'teacher_class');
const userlist = r => require.ensure([], () => r(require('@/page/userList')), 'userList');
const qipulist = r => require.ensure([], () => r(require('@/page/qipuList')), 'qipuList');
const qipu_list = r => require.ensure([], () => r(require('@/page/qipu_list')), 'qipu_list');
const cuotiben = r => require.ensure([], () => r(require('@/page/cuotiben')), 'cuotiben');
const tk_homework = r => require.ensure([], () => r(require('@/page/tk_homework')), 'tk_homework');
const student_homework = r => require.ensure([], () => r(require('@/page/student_homework')), 'student_homework');
const level = r => require.ensure([], () => r(require('@/page/level')), 'level');
const tiku = r => require.ensure([], () => r(require('@/page/tiku')), 'tiku');
const duiju_level = r => require.ensure([], () => r(require('@/page/duiju_level')), 'duiju_level');
const qipan = r => require.ensure([], () => r(require('@/page/qipan')), 'qipan');
const duiyiqipan = r => require.ensure([], () => r(require('@/page/duiyiqipan')), 'duiyiqipan');
const school_manage = r => require.ensure([], () => r(require('@/page/school_manage')), 'school_manage');
const shenhe = r => require.ensure([], () => r(require('@/page/shenhe')), 'shenhe');
const qixiaojianjie = r => require.ensure([], () => r(require('@/page/qixiaojianjie')), 'qixiaojianjie');
const help = r => require.ensure([], () => r(require('@/page/help')), 'help');
const rule = r => require.ensure([], () => r(require('@/page/rule')), 'rule');
const billboard = r => require.ensure([], () => r(require('@/page/billboard')), 'billboard');
const qimeng_billboard = r => require.ensure([], () => r(require('@/page/qimeng_billboard')), 'qimeng_billboard');
const qixiao_billboard = r => require.ensure([], () => r(require('@/page/qixiao_billboard')), 'qixiao_billboard');
const teacher_billboard = r => require.ensure([], () => r(require('@/page/teacher_billboard')), 'teacher_billboard');
const pay_card_info = r => require.ensure([], () => r(require('@/page/pay_card_info')), 'pay_card_info');
const billboard_cuoti = r => require.ensure([], () => r(require('@/page/billboard_cuoti')), 'billboard_cuoti');
const qimeng = r => require.ensure([], () => r(require('@/page/qimeng')), 'qimeng');
const peizhi = r => require.ensure([], () => r(require('@/page/peizhi')), 'peizhi');
const jiaoxue_peizhi = r => require.ensure([], () => r(require('@/page/jiaoxue_peizhi')), 'jiaoxue_peizhi');
const duiyi_user = r => require.ensure([], () => r(require('@/page/duiyi_user')), 'duiyi_user');
const duiju = r => require.ensure([], () => r(require('@/page/duiju')), 'duiju');
const index = r => require.ensure([], () => r(require('@/page/index')), 'index');
const daguan_list = r => require.ensure([], () => r(require('@/page/daguan_list')), 'daguan_list');
const setup = r => require.ensure([], () => r(require('@/page/setup')), 'setup');
const addStudents = r => require.ensure([], () => r(require('@/page/addStudents')), 'addStudents');
const bisaibianpai = r => require.ensure([], () => r(require('@/page/bisai_bianpai')), 'bisaibianpai');
// const maplist = r => require.ensure([], () => r(require('@/page/mapList')), 'mapList');
// const shapelist = r => require.ensure([], () => r(require('@/page/shapeList')), 'shapeList');
// const friendlist = r => require.ensure([], () => r(require('@/page/friendList')), 'friendList');
// const coopmaplist = r => require.ensure([], () => r(require('@/page/coopMapList')), 'coopmapList');
// const datalist = r => require.ensure([], () => r(require('@/page/dataList')), 'dataList');
// const statislist = r => require.ensure([], () => r(require('@/page/statisList')), 'statisList');
// const adduser = r => require.ensure([], () => r(require('@/page/addUser')), 'addUser');
// const addadmin = r => require.ensure([], () => r(require('@/page/addAdmin')), 'addAdmin');
// const addmap = r => require.ensure([], () => r(require('@/page/addMap')), 'addMap');
// const adddata = r => require.ensure([], () => r(require('@/page/addData')), 'addData');
// const info = r => require.ensure([], () => r(require('@/page/info')), 'info');
// const adminset = r => require.ensure([], () => r(require('@/page/adminSet')), 'adminSet');
// const classify = r => require.ensure([], () => r(require('@/page/classify')), 'classify');
// const configSet = r => require.ensure([], () => r(require('@/page/configSet')), 'configSet');

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'login',
            component: login
        },
        {
            path: '/manage',
            name: '',
            component: manage,
            children: [
                {
                    path: '/index',
                    component: index,
                    meta: ['首页','']
                }, 
                {
                    path: '/userlist/:class_id',
                    component: userlist,
                    meta: ['班级管理', '学员列表']
                },  
                {
                    path: '/teacher_class',
                    component: teacher_class,
                    meta: ['老师班级', '学员列表']
                }, 
                {
                    path: '/daguan_list',
                    component: daguan_list,
                    meta: ['班级管理', '打关列表']
                },
                {
                    path: '/level',
                    component: level,
                    meta: ['做题关卡', '关卡列表']
                },,
                {
                    path: '/tiku',
                    component: tiku,
                    meta: ['题库', '题库列表']
                },
                {
                    path: '/duiju_level/:id',
                    component: duiju_level,
                    meta: ['对局关卡', '关卡列表']
                },
                {
                    path: '/qipulist',
                    component: qipulist,
                    meta: ['棋谱', '棋谱列表']
                },
                {
                    path: '/qipu_list',
                    component: qipu_list,
                    meta: ['棋谱', '棋谱列表']
                },                
                {
                    path: '/cuotiben',
                    component: cuotiben,
                    meta: ['错题本', '列表']
                },
                {
                    path: '/tk_homework',
                    component: tk_homework,
                    meta: ['家庭作业', '列表']
                },
                {
                    path: '/student_homework',
                    component: student_homework,
                    meta: ['我的作业', '列表']
                },
                {
                    path: '/qipan',
                    component: qipan,
                    meta: ['数据管理', '棋盘']
                },
                {
                    path: '/duiyiqipan',
                    component: duiyiqipan,
                    meta: ['数据管理', '棋盘']
                },
                {
                    path: '/billboard',
                    component: billboard,
                    meta: ['排行榜', '']
                },
                {
                    path: '/qimeng_billboard',
                    component: qimeng_billboard,
                    meta: ['排行榜', '']
                },
                {
                    path: '/qixiao_billboard',
                    component: qixiao_billboard,
                    meta: ['棋校排行榜', '']
                },
                {
                    path: '/teacher_billboard',
                    component: teacher_billboard,
                    meta: ['老师排行榜', '']
                },
                {
                    path: '/pay_card_info',
                    component: pay_card_info,
                    meta: ['购卡详情表', '']
                },
                {
                    path: '/billboard_cuoti',
                    component: billboard_cuoti,
                    meta: ['错题榜', '']
                },
                {
                    path: '/qimeng',
                    component: qimeng,
                    meta: ['启蒙', '']
                },
                {
                    path: '/peizhi',
                    component: peizhi,
                    meta: ['AI', '配置']
                },
                {
                    path: '/jiaoxue_peizhi',
                    component: jiaoxue_peizhi,
                    meta: ['教学棋盘', '配置']
                },
                {
                    path: '/duiyi_user',
                    component: duiyi_user,
                    meta: ['在线对弈', '在线人员']
                },
                {
                    path: '/duiju',
                    component: duiju,
                    meta: ['在线对弈', '']
                },
                {
                    path: '/setup',
                    component: setup,
                    meta: ['设置', '']
                },
                {
                    path: '/addStudents',
                    component: addStudents,
                    meta: ['班级管理', '添加学员']
                },
                {
                    path: '/school_manage',
                    component: school_manage,
                    meta: ['学校管理', '']
                },
                {
                    path: '/qixiaojianjie',
                    component: qixiaojianjie,
                    meta: ['棋校简介', '']
                },
                {
                    path: '/help',
                    component: help,
                    meta: ['帮助', '']
                },
                {
                    path: '/bisaibianpai',
                    component: bisaibianpai,
                    meta: ['比赛编排', '']
                },
                {
                    path: '/rule',
                    component: rule,
                    meta: ['围棋规则', '']
                },
                {
                    path: '/shenhe',
                    component: shenhe,
                    meta: ['审核', '']
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js